'use client';

import { Post } from '@prisma/client';
import { useState } from 'react';
import useSWR from 'swr';

import { post } from '@/shared/config/endpoints';
import { file as fileEdp } from '@/shared/config/endpoints';

const fetcher = (url: string) => fetch(url, { method: 'GET' }).then((res) => res.json());

export function usePosts() {
  const { data, isLoading } = useSWR<{ posts: Post[] }>(post.getList, fetcher, {
    fallbackData: { posts: [] }
  });
  const [html, setHtml] = useState('');
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [pictureOwnerAttr, setPictureOwnerAttr] = useState<string | null>(null);

  const cretePost = async (file: File & { preview: string }) => {
    try {
      const response = await fetch(
        `${fileEdp.upload}?filename=${file?.name}&bucketName=dogs-blog-bucket`,
        { method: 'POST', body: file }
      );

      const result = await response.json();

      const resultPost = await fetch('api/post/create', {
        method: 'POST',
        body: JSON.stringify({
          post: {
            metaTitle,
            metaDescription,
            content: html,
            coverPicture: result.imageName,
            coverPictureOwnerAttribute: pictureOwnerAttr ?? null
          } as Post
        }),
        headers: {
          'Content-Type': 'application/json'
        },
        next: { tags: ['posts'] }
      });

      if (resultPost) {
        await fetch('sitemap.xml', { method: 'GET' });
        await fetch('feed.xml', { method: 'GET' });
        await fetch('yandex.feed.xml', { method: 'GET' });
        await fetch('search.json', { method: 'GET' });
        alert('Post created');
      }
    } catch (error) {
      throw new Error((error as Error).message);
    }
  };

  return {
    isLoading: isLoading,
    posts: data?.posts ?? [],
    cretePost,
    setHtml,
    setMetaTitle,
    setMetaDescription,
    setPictureOwnerAttr,
    html,
    pictureOwnerAttr
  };
}
